<template>
  <div>
    <Title :pages="[{ icon: 'flask', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-6">
             
                <div class="col pt-0">
                  <v-text-field clearable v-model="name_selected" autocomplete="off" class="pt-0 mt-0" label="Nombre"></v-text-field>
                </div>

                <div class="col pt-0">
                  <v-text-field clearable v-model="sku_selected" autocomplete="off" class="pt-0 mt-0" label="SKU (Producto Final)"></v-text-field>
                </div>
                <div class="col pt-0">
                  <v-combobox
                    v-model="type_selected"
                    data-vv-as="Tipo"
                    name="type_selected"
                    :items="types"
                    item-text="name"
                    item-value="id"
                    label="Tipo"
                    class="pt-0 mt-0"
                    clearable
                  ></v-combobox>
                </div>

              </div>
              <div class="row">
                <div class="col pt-0">
                  <v-radio-group
                    v-model="selected_status"
                    row
                    class="mt-0 mb-0"
                  >
                    <v-radio label="Habilitado" :value="true"></v-radio>
                    <v-radio label="No habilitado" :value="false"></v-radio>
                    <v-radio label="Todos" value="all"></v-radio>
                  </v-radio-group>
                </div>
                <div class="col pt-0 text-end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>

            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.product_final ? props.item.product_final.name : '' }}</td>
              <td>
                {{ props.item.amount_result }} 
                {{ props.item.product_final && props.item.product_final.base_presentation && props.item.product_final.base_presentation.storage_unit ? props.item.product_final.base_presentation.storage_unit.name : '' }}
              </td>
              <td>{{ props.item.type.name }}</td>
              <td>{{ props.item.enabled ? "Sí" : "No" }}</td>
              <td class="text-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(props.item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="create_access" v-on="on" small color="green" class="mr-2" @click="cloneItem(props.item)"> content_copy </v-icon>
                  </template>
                  <span>Clonar</span>
                </v-tooltip>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="purple" class="mr-2" v-bind="attrs" v-on="on"> print </v-icon>
                  </template>

                  <v-list>
                    <v-list-item dense @click="printItem(props.item)">
                      <v-list-item-title>Descargar PDF</v-list-item-title>
                    </v-list-item>

                    <v-list-item dense @click="printItem(props.item, true)">
                      <v-list-item-title>Ver PDF</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
      <DialogYesNo 
        :open="dialog_clone" 
        title="Clonar Formula" 
        :message="clone_message" 
        @cancel="dialog_clone = false" 
        @accept="cloneItemConfirm" 
        :loading="loading"
      />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { formulaService } from "@/libs/ws/formulaService";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import Modal from "./Modal.vue";
import RolMixin from "@/mixins/RolMixin.vue";

export default {
  components: { Title, Modal, DialogDelete, DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: formulaService,
      page_title: "Formulas",
      modal_title: "Formula",
      mainItem: {
        id: "",
        name: "",
        amount_result: 0,
        type: "",
        product_final: null,
        items: [],
        enabled: false,
      },
      defaultItem: null,
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "Producto Resultado", value: "product_final.name", align: "left" },
        { text: "Cantidad y Unidad", value: "amount_result", align: "left" },
        { text: "Tipo", value: "type", align: "left" },
        { text: "Habilitado", value: "enabled", align: "left" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
      dialog_clone: false,
      clone_message: '',
      item_to_clone: null,
      selected_status: true,
      name_selected: null,
      sku_selected: null,
      type_selected: null,
      types: [],
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadTypes();
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    loadTypes() {
      this.service
        .list_types()
        .then((response) => {
          this.types = response.result;  
        })
        .catch((e) => {
          console.log("types.list error");
          console.log(e);
        });
    },
    getFilterParams() {
      const param = {
        enabled: this.selected_status,
        type: this.type_selected != null ? this.type_selected : null,
        sku: this.sku_selected != null ? this.sku_selected : null,
        name: this.name_selected != null ? this.name_selected : null,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    cloneItem(item) {
      this.item_to_clone = item;
      this.clone_message = `¿Está seguro que desea clonar la fórmula "${item.name}"?`;
      this.dialog_clone = true;
    },
    cloneItemConfirm() {
      if (!this.item_to_clone) return;
      
      this.loading = true;
      
      // Preparar los datos para crear una copia
      let clonedData = {
        name: this.item_to_clone.name + ' (Copia)',
        amount_result: this.item_to_clone.amount_result,
        type: this.item_to_clone.type,
        product_final: this.item_to_clone.product_final,
        enabled: this.item_to_clone.enabled,
        items_arr: this.item_to_clone.items || []
      };
      
      formulaService
        .create(clonedData)
        .then((response) => {
          if (response.status && response.result.id > 0) {
            this.$toast.success("La fórmula se clonó correctamente", "OK");
            this.loadList(this.service, this.getFilterParams());
            this.dialog_clone = false;
            this.item_to_clone = null;
          } else {
            this.$toast.error(response.msg || "Error al clonar la fórmula", "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Error al clonar la fórmula", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printItem(item, open = false) {
      this.loading = true;
      formulaService
        .print(item.id)
        .then((response) => {
          let nombre = item.name;
          if (!generalService.downloadPdf(response, "formula_" + nombre + ".pdf", open)) {
            this.$toast.error("Error al generar el PDF", "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error("Error al generar el PDF", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service, this.getFilterParams());
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
